module.exports = __webpack_public_path__ + "static/media/Cats eyes 06_ENGELSKA-mixdown.29b7ab5e.mp3";